import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { LogsService } from 'src/app/services/logs.service';
import {environment} from "../../../environments/environment";
import videojs from 'video.js';
import { Label, VideoDetail } from 'src/app/models/video';

@Component({
  selector: 'app-navigate-transcript',
  templateUrl: './navigate-transcript.component.html',
  styleUrls: ['./navigate-transcript.component.scss']
})
export class NavigateTranscriptComponent implements OnInit {

  currentTime: number | undefined = 0;

  transcript: any[] = [];
  groupedTranscript: any[] = [];
  @ViewChild('transcriptContainer') transcriptContainer!: ElementRef;

  searchTerm: string = '';
  searchObject: {list: any[]; index: number;} = {
    list: [],
    index: 0
  };
  isNotResult: boolean = false;

  token = ''
  breadcrumbs = []
  user_id: string;
  videoId:string = ''
  ProcedureValue:any = {}
  poster:string = ''
  module = "transcripción"

  isTranscript: number = 0;

  video: VideoDetail = {
    CiudadCodAudiencia: "",
    EntidadCodAudiencia: "",
    EspecialidadCodAudiencia: "",
    Estado: "",
    Etiquetas: [],
    FechaGrabacion: "",
    FechaRegistro: "",
    GrabacionCod: 0,
    HoraGrabacion: "",
    JuzgadoCodAudiencia: "",
    JuzgadoNombre: "",
    NombreArchivo: "",
    NombreSala: "",
    NumeroGrabacion: "",
    OrigenGrabacion: "",
    ProcesoCod: "",
    RutaDecodificado: "",
    RutaOriginal: "",
    TipoAudiencia: "",
    VideosCompartidos: [],
    Adjuntos: [],
    VideoCompartidoUsuarios: [],
    DistritoCod: '',
    DistritoNombre: '',
    AreaCod: '',
    AreaNombre: '',
    JurisdiccionCod: '',
    JurisdiccionNombre: '',
    NombreJuez: '',
    TiempoEtiquetas: [],
    CaracterReservado: true,
    Duracion: '',
    EtiquetasLista: ''
  }

  data_tag: Label = {
    EtiquetaCod: 0,
    FechaRegistro: '',
    GrabacionCod: '0',
    Nombre: ''
  }


  options = {
    autoplay: false,
    controls: true,
    preload: 'metadata',
    sources: [
      {
        src: '',
        type: 'video/mp4',
        poster: ''
      }
    ]
  };
  player: videojs.Player;
  @ViewChild('idVideo', {static: true}) idVideo: ElementRef;

  constructor(private activeRoute: ActivatedRoute,
    public apiService: ApiService,
    private router: Router,
    public logService: LogsService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token')
    this.user_id = localStorage.getItem('user_id');
    if(this.user_id != null)
    {
      this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))

      this.activeRoute.params.subscribe(params => {

        this.videoId = params.id;
        this.data_tag.GrabacionCod = this.videoId

        if(this.ProcedureValue.type == 'scheduler'){
          this.router.navigate([`/detail/${this.videoId}`])
        }

        this.GetVideoDetail()
        let formT = localStorage.getItem('formTransliterator')
        if (formT == null){
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Detalle del video', url: '/detail/'+ this.videoId},
            {name: 'transcripción', url: '/transcript/'+ this.videoId}
          ]
        }else{
          this.breadcrumbs = [
            {name: 'Inicio', url: '/'+this.token+'/'+localStorage.getItem('user_id')},
            //{name: 'Inicio', url: '/'+localStorage.getItem('user_id')},
            {name: 'Búsqueda por transliteración', url: '/transliterator'},
            {name: 'Detalle del video', url: '/detail/'+ this.videoId},
            {name: 'transcripción', url: '/transcript/'+ this.videoId}
          ]
        }

      })


    }
    else
      this.exit()

  }

  GetVideoDetail(): void{
    this.apiService.GetInfoVideo(this.videoId,localStorage.getItem('user_id')).subscribe(
      request=>{
        if(request.GrabacionCod == -1) this.exit()
        this.video = <VideoDetail> request;
        console.log(this.video);
        let src_video = environment.urlApiVideos.url+'/api/filevideo/descargar?videoName='+this.video.NombreArchivo+"&UserID="+this.user_id
        this.options.sources[0].src = src_video;
        const type = this.video.NombreArchivo.split('.')[1]
        if(type === 'mp3'){
          this.options.sources[0].type = 'audio/mp3'
          this.poster = '../../../assets/poster.jpg'
        }else{
          this.options.sources[0].type = 'video/mp4'
          this.poster = ''
        }
        this.player = videojs(this.idVideo.nativeElement, this.options, function onPlayerReady() {
          console.log('onPlayerReady', this);
        })
        this.player.on('timeupdate', () => {
          this.currentTime = this.player.currentTime();
          this.updateTranscript();
        });
        this.player.on('error', () => {
          console.log(this.player.error());
          if(this.player.error().code == 4){
            console.log('error 4');
            this.logService.createLogErrorDireccion(`No se encuentra grabación`,this.video.GrabacionCod,this.video.RutaDecodificado,this.video['Almacenamiento'],4).subscribe({
              next:res=>{
                console.log(res);
              },
              error:err=>console.error(err)
            })

          }
          if(this.player.error().code == 3) console.log('error 3');
        });
        this.logService.createLog(this.module,
          "visualización del video " +this.video.NombreArchivo).subscribe(
          request =>console.log("ok"),
          error => console.error(error)
        )
        this.ProcedureValue = JSON.parse(localStorage.getItem('data_user'))
        this.loadTranscript();
      },
      error => {

      }
    )
  }

  exit(): void{
    this.router.navigate(['/'])
  }

  searchTermChange(){
    this.searchObject.list = [];
    this.searchObject.index = 0;
    this.isNotResult = false;
  }

  cleanInput(){
    this.searchObject.list = [];
    this.searchObject.index = 0;
    this.searchTerm = ""
    this.isNotResult = false;
  }

  loadTranscript() {
    /* fetch('assets/PruebaVideoRelatoria-23062830424.json')
      .then(response => response.json())
      .then(data => {
        if (data.results && data.results.channels && data.results.channels.length > 0) {
          const alternatives = data.results.channels[0].alternatives;
          if (alternatives && alternatives.length > 0) {
            this.transcript = alternatives[0].words;
            this.groupTranscriptBySpeakers();
          }
        }
      }); */
      this.apiService.getTrasncritption(this.video.GrabacionCod).subscribe({
        next:res=>{
          console.log('aquí');
          console.log(res)
          if(!res.TranscriptionObject){
            this.isTranscript = 2;
            return
          }
          let data = JSON.parse(res.TranscriptionObject)
          console.log(data);
          if (data.results && data.results.channels && data.results.channels.length > 0) {
            this.isTranscript = 1;
            const alternatives = data.results.channels[0].alternatives;
            if (alternatives && alternatives.length > 0) {
              this.transcript = alternatives[0].words;
              this.groupTranscriptBySpeakers();
            }
          }
        },
        error:(error)=>{
          console.error(error);
        }
      })
  }

  groupTranscriptBySpeakers() {
    let currentGroup: any[] = [];

    this.transcript.forEach((word, index) => {
      if (currentGroup.length === 0 || currentGroup[0].speaker === word.speaker) {
        currentGroup.push(word);
      } else {
        this.groupedTranscript.push(currentGroup);
        currentGroup = [word];
      }
    });

    if (currentGroup.length > 0) {
      this.groupedTranscript.push(currentGroup);
    }
  }

  changeTime(time: number) {
    console.log('Update time:', time);
    this.onTimeUpdated(time);
  }

  onTimeUpdated(time: number): void {
    console.log('Time updated from child component:', time);
    this.updateCurrentTime(time);
  }

  pause():void{
    this.player.pause();
  }

  updateCurrentTime(time: number): void {
    this.player.currentTime(time);
    if(!this.isPlaying) this.player.play();
  }

  isPlaying(): boolean {
    return !this.player.paused();
  }

  updateTranscript() {
    this.scrollToHighlighted();
  }

  formatTime(seconds: number): string {
    if (!isNaN(seconds) && seconds >= 0) {
      const date = new Date(seconds * 1000);
      return date.toISOString().slice(11, 19);
    }
    return '00:00:00';
  }

  isHighlighted(wordTime: number, currentTime: number | undefined): boolean {
    if (currentTime) {
      return wordTime <= currentTime && currentTime < wordTime + 3;
    } else {
      return false;
    }
  }

 /*  scrollToHighlighted() {
    setTimeout(() => {
      //const highlightedElement = this.transcriptContainer.nativeElement.querySelector('.highlightView');
      const highlightedElement = this.transcriptContainer.nativeElement.querySelector('.highlight');
      console.log(highlightedElement);
      if (highlightedElement) {
        const offset = 20 * highlightedElement.offsetHeight;
        let topScroll = this.transcriptContainer.nativeElement.offsetTop;
        this.transcriptContainer.nativeElement.scrollTop = topScroll + highlightedElement.offsetTop - offset;
      }
    }, 100);
  } */

  scrollToHighlighted() {
    setTimeout(() => {
      const highlightedElement = this.transcriptContainer.nativeElement.querySelector('.highlight');
      if (highlightedElement) {
        const containerRect = this.transcriptContainer.nativeElement.getBoundingClientRect();
        const elementRect = highlightedElement.getBoundingClientRect();

        // Check if the highlighted element is already in view
        if (elementRect.top < containerRect.top || elementRect.bottom > containerRect.bottom) {
          const offset = elementRect.top - containerRect.top - 20 * highlightedElement.offsetHeight;
          this.transcriptContainer.nativeElement.scrollTop += offset;
        }
      }
    }, 100);
  }

  searchWord() {
    if (!this.searchTerm) {
      return;
    }

    this.searchObject.list = [];

    for (let speakerGroup of this.groupedTranscript) {
      for (let word of speakerGroup) {
        if (word.punctuated_word.toLowerCase().includes(this.searchTerm.toLowerCase())) {
          this.searchObject.list.push(word)
        }
      }
    }

    if(this.searchObject.list.length<=0){
      this.isNotResult = true;
    }else{
      this.changeTime(this.searchObject.list[this.searchObject.index].start)
      this.pause();
    }

  }

  updateSearch():string{
    return `${this.searchObject.index+1} de ${this.searchObject.list.length}`
  }

  changeIndexWord(key:string){
    switch(key){
      case "UP":
        if(this.searchObject.index+1<this.searchObject.list.length){
          this.searchObject.index = this.searchObject.index+1;
        }
        else{
          this.searchObject.index = 0;
        }
        break;
      case "DOWN":
        if(this.searchObject.index-1>=0){
          this.searchObject.index = this.searchObject.index-1;
        }
        else{
          this.searchObject.index = this.searchObject.list.length-1;
        }
        break;
      default:
        return;
    }
    this.changeTime(this.searchObject.list[this.searchObject.index].start)
    this.pause();
  }

}
